import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/index.jsx';

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="container page page-center">
      <h1>{t('notFound.title')}</h1>
      <p className="muted">{t('notFound.text')}</p>
      <Link className="btn btn-primary" to="/">{t('notFound.home')}</Link>
    </div>
  );
}
